import {Component, EventEmitter, Input, Output, booleanAttribute} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'sigecom-input-search-new',
  template: `
    <div class="rounded-xl border {{ padding }} border-[#C9C9C9] overflow-hidden flex">
      <input class="h-full w-full rounded-s-md bg-white outline-none" #searchInput
        [value]="search"
        type="search"
        placeholder="{{ placeholder || 'Pesquisar...' }}"
        (input)="onSearchChange(searchInput.value)"
      />
      <div class="cursor-pointer flex items-center px-1.5"
        (click)="onSearchChange(searchInput.value)">
        <fa-icon [icon]="'magnifying-glass'"></fa-icon>
      </div>
    </div>
  `,
})
export class InputSearchNewComponent  {
  @Input() placeholder?: string;
  @Input() search: string = "";
  @Input({ transform: booleanAttribute }) lowercase: boolean = false;
  @Output() searchChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() padding: string = 'p-1';


  onSearchChange(newValue: string) {
    this.search = newValue;
    this.searchChange.emit(this.lowercase ? newValue : this.search.toUpperCase());
  }

 
}
